import { Directive, HostBinding, Input } from '@angular/core';

@Directive({selector: 'cyno-info'})
export class CynoInfoDirective {
    @HostBinding('class') class: string = 'control-info';
    @Input() visible: boolean = true;
}
